export const arabicNumbers = ['۰', '۱', '۲', '۳', '٤', '٥', '٦', '۷', '۸', '۹']
export const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']

const ToEnglishNumber = (number: number | string | null | undefined) => {
	if (number == null) return ''
	if (typeof number === 'number') number = number.toString()

	for (let i = 0; i <= 9; i++) number = number.replace(new RegExp(`${arabicNumbers[i]}`, 'g'), i.toString())
	for (let i = 0; i <= 9; i++) number = number.replace(new RegExp(`${persianNumbers[i]}`, 'g'), i.toString())

	return number
}

export default ToEnglishNumber
